module.exports = __webpack_public_path__ + "static/media/close.74b090bc.svg";